export type DisplayMode = "float" | "overlay";
